var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"home-main"},[_c('div',{staticClass:"map-data"},[_c('div',{staticClass:"map-area"},[_c('home-map',{attrs:{"city-data":_vm.cityData,"time":_vm.timeSection,"dataType":_vm.dataType,"title":_vm.title}})],1),_c('map-card',{attrs:{"time":_vm.timeSection,"changeType":_vm.changeType}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }